"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withFileSystemContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FileSystemContext_1 = require("./FileSystemContext");
function withFileSystemContext(mapContext) {
    return (WrappedComponent) => {
        const WrapperComponent = (props) => {
            const context = (0, react_1.useContext)(FileSystemContext_1.FileSystemContext);
            const contextProps = mapContext(context);
            return (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props, contextProps), void 0);
        };
        return WrapperComponent;
    };
}
exports.withFileSystemContext = withFileSystemContext;
//# sourceMappingURL=withFileSystemContext.js.map